import { module } from 'modujs';
import Swiper, { Navigation, Lazy } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.initEvents()

        this.onResize()
    }

    initSwiper() {
        this.carousel = new Swiper(this.el, {
            init: true,
            modules: [Navigation, Lazy],
            spaceBetween: 10,
            slidesPerView: 1.1,
            watchSlidesProgress: true,
            grabCursor: true,
            navigation: {
                nextEl: '[data-navigation="next"]',
                prevEl: '[data-navigation="prev"]',
            },
            breakpoints: {
                700: {
                    slidesPerView: 1.5,
                }
            },
            // Disable preloading of all images
            preloadImages: false,
            // Enable lazy loading
            lazy: {
                elementClass: 'c-lazy_image',
                loadedClass: '-lazy-loaded'
            },
        })
    }

    initEvents() {
        this.resizeBind = this.onResize.bind(this)
        window.addEventListener('resize', this.resizeBind)
    }

    onResize() {
        if(window.innerWidth > 1000) {
            if(this.carousel?.el.classList.contains('swiper-initialized')) {
                this.carousel?.destroy(true, true)
                this.carousel = null
            }
        } else if(window.innerWidth <= 1000) {
            if(!this.carousel?.el.classList.contains('swiper-initialized')) {
                this.initSwiper()
            }
        }
    }

    destroy() {
        super.destroy()

        this.carousel?.destroy(true, true);
        window.removeEventListener('resize', this.resizeBind)
    }
}
